<template>
    <div :style="{position: device === 'pc' ? 'relative' : '', margin: device === 'pc' ? '0 auto' : ''}" style="height: 100%;overflow:hidden; max-width: 600px;">
        <!--<button @click="testPermission" style="position: fixed;top: 0px;left: 0px;z-index: 9999;">권한 체크</button>-->
        <router-view></router-view>
    </div>
</template>

<script>
import GpsManager from "@/modules/GpsManager";
import DeviceInfoManager from "./modules/DeviceInfoManager";
// import Pedometer from '@/modules/Pedometer'

export default {
    name: 'App',
    components: {
        // HelloWorld
    },
    data() {
        return {
            device: null
        }
    },
    methods : {
    },
    created() {
        const device = this.$cookies.get('device');
        this.device = device
        GpsManager.init(device);
        DeviceInfoManager.init(device);
        window.deviceInfoManager = DeviceInfoManager;
        //어느 버전 이상만 풀화면 동작하도록
        setTimeout(async () => {
            if (process.env.NODE_ENV === 'development' && (device === 'ios' || device === 'android' )) {
                DeviceInfoManager.setAppVersion(parseInt(999999));

                this.$GlobalStore.setStatusBarHeight(await DeviceInfoManager.getStatusHeight());
                this.$GlobalStore.setNavigationBarHeight(await DeviceInfoManager.getNavigationBarHeight());
            } else {
                const app_version = this.$cookies.get('appv');
                if (!app_version) return;

                let is_apply = false;

                if (device === 'ios') {
                    is_apply = parseInt(app_version) >= 31;
                } else if (device === 'android') {
                    is_apply = parseInt(app_version) >= 21;
                }

                DeviceInfoManager.setAppVersion(parseInt(app_version));

                if (is_apply) {
                    this.$GlobalStore.setStatusBarHeight(await DeviceInfoManager.getStatusHeight());
                    this.$GlobalStore.setNavigationBarHeight(await DeviceInfoManager.getNavigationBarHeight());
                }
            }
        }, 0);

        setTimeout(() => {
            // this.$GlobalStore.addModal('UploadGuidePopup', {isModalBackTransparent : true, transitionName : ''})
            // this.$GlobalStore.addModal('AllMemberTalkPopup', {isModalBackTransparent : true,  transitionName: ''});
            // window.Android.showIgnoreBatteryOptimization();
            // setTimeout(async () => {
            //     this.$Util.renewFriends();
            // }, 5000);
            // setTimeout(async () => {
            //     this.$GlobalStore.addModal('TestSecretPay');
            // }, 2000);
            // setTimeout(async () => {
            //     this.$GlobalStore.addModal('ParentAuth', {selected_player_type : 'elite'});
                // this.$GlobalStore.addModal('ParentAuth', {selected_player_type : 'challenger'});
            // }, 2000);
            // this.$Axios.showChattingBySoccerJoinIdx('2316');
            // this.$GlobalStore.addModal('MyPosition')
            // this.$GlobalStore.setIsShowBookmarkPopupNotExpert()
            // this.$GlobalStore.addModal('SendReview', {join_schedule_idx : 2551})
            // this.$GlobalStore.addModal('TeamTrainingMng')
            // this.$GlobalStore.addModal('TeamTrainingMngHistory')
            // this.$GlobalStore.addModal('TestParentPay', {status_bar_text_color : 'dark'})
            // setTimeout(() => {
            //     this.$GlobalStore.addModal('TestParentPay', {status_bar_text_color : 'white'})
            // }, 1000)
            // setTimeout(() => {
            //     this.$GlobalStore.addModal('TestParentPay', {status_bar_text_color : 'dark'})
            // }, 2000)
            // this.$GlobalStore.showToastVer2('test1234', TOAST_TYPE.CHECK)
            // this.$GlobalStore.addModal('TestCoachChat', { })
            // this.$GlobalStore.addModal('TestOpenChat', { })
            // this.$GlobalStore.addModal('TestParentPay', { })
            // this.$GlobalStore.addModal('TestRequestPay', { })
            // this.$GlobalStore.addModal('SignupCommonFrame', { id: 'hagsulsa30@naver.com', password: '123456', step: 'PURPOSE', titleText: '사커하우에 오신 이유를<br>알려주세요' })
            // this.$Util.showChatWithAdmin();
            // this.$GlobalStore.addModal('MyPositionPro', { originallyPosition: 'CM'})
            // this.$GlobalStore.addModal('TeamTrainingHistoryCalendarPopup', {transitionName: '', isModalBackTransparent : true, repeat_schedule_idx : 23})
            // this.$GlobalStore.addModal('MakeClassScheduleFeedPopup', {transitionName: '', isModalBackTransparent : true})
            // this.$GlobalStore.addModal('MyClassReservation', {mode : 0})
            // this.$GlobalStore.addModal('MyClassReservation', {mode : 2, join_schedule_idx : 2354})

            // this.$GlobalStore.addModal('RegistTypeSelect')
            // this.$GlobalStore.addModal('MemberRegistStepTwo')
            // this.$Axios.showChattingBySoccerJoinIdx(1077);
            // this.$GlobalStore.addModal('InviteMemberPopup')
            // this.$GlobalStore.addModal('TestModal')
            // this.$GlobalStore.addModal('FindSearch', {completeAction : (place) => {console.log(place)}})
            // this.$GlobalStore.addModal('MercenaryMainModalPopup', {transitionName: '', isModalBackTransparent: true, selectDong : {dong : '거제동', code : '2647010100'}})
            // this.$GlobalStore.addModal('HomeFeedMemberTalkDetailPopup', {transitionName: '', isModalBackTransparent: true, membertalk_idx : 159})
            // this.$GlobalStore.addModal('MercenaryScheduleDetailPopup', {transitionName: '', isModalBackTransparent: true, schedule_idx : 1310})
            // this.$GlobalStore.addModal('CommonClassPopup', {transitionName: '', isModalBackTransparent: true,})
            // this.$GlobalStore.addModal('CoachLessonManage');
            // this.$GlobalStore.addModal('CoachIntroduceManage');
            // this.$GlobalStore.addModal('SoccerHowReplyPopup', {transitionName : '', isModalBackTransparent : true, idx : '2224', replyDeep : 1});
            // this.$GlobalStore.addModal('ScheduleHistoryManage', {});
            // this.$GlobalStore.addModal('AlarmMessageAllManage')
            // this.$GlobalStore.addModal('ActivityAndSettings')
            // this.$GlobalStore.addModal('CoachRegisterExplanation', {step : 2})
            // this.$GlobalStore.addModal('CoachRegister')
            // this.$GlobalStore.addModal('CoachDocComplete', {type : 2});
            // this.$GlobalStore.addModal('CoachDocRegister', {mode : 'insert', type : 2});
            // this.$GlobalStore.addModal('CoachDocRegister')
            // this.$GlobalStore.addModal('CoachDocComplete')
            // this.$GlobalStore.addModal('SupportActivity')
            // this.$GlobalStore.addModal('CoachVerifiedDocConfirm', {step : 0})
            // Pedometer.getToday().then((res)=>{
            //     this.$GlobalStore.showAlert(JSON.stringify(res.data[0]));
            // });
            // Pedometer.getToday().then((res)=>{
            //     let count = 0;
            //     if(res.data.length > 0) count = res.data[0].count;
            //     this.$GlobalStore.showAlert(count); //count가 오늘 걸음수
            // });
            // Pedometer.getLast(7).then((res)=>{
            //     let count = 0;
            //     let yesterday_diff = 0;
            //     if(res.data.length > 0) {
            //         count = parseInt((res.data.reduce((acc, item) => acc + item.count, 0)) / 7)
            //         yesterday_diff = res.data[0].count - res.data[1].count
            //     }
            //     this.$GlobalStore.showAlert(count); //평균 걸음수(7일)
            //     this.$GlobalStore.showAlert(yesterday_diff); //어제 오늘 걸음수 차이
            // });
        }, 3000)

    }
}
</script>
<style>
:root {
    --global-font-family: NotoSansKorea, san-serif;
    --color-main: #ff7100;
    --color-main-user: #ff7100;
    --color-main-coach: #699BF7;
    --color-tab: #101014;
    --color-tab-font: white;
    color: #101014
}

.set_full_screen {
    padding-top: 0px !important;
}

.hide_scroll {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.hide_scroll::-webkit-scrollbar {
    display: none;
}

img {
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
}
</style>
<style scoped></style>
